export default __webpack_public_path__ + "static/media/download.e9c6ad91.svg";